import React, {useCallback, useContext} from 'react';
import {ServiceContext} from '../../../../components/Services';
import ActionHolder from '../../components/Actions';

export default function Actions(
  {
    item,
    setLoading,
    openDialogs,
    toggleDialog,
    toggleError,
    page = 1,
    length = 5,
    updatePageCount
  }) {
  const services = useContext(ServiceContext);

  const loadActivity = useCallback((currentPage, selectedLength) => {
    return services.stockItem.getItemActivity(
      item.id,
      item.archived ? {filter: {archive: 'only'}} : {},
      currentPage,
      selectedLength
    );
  }, [services, item]);

  return (
    <ActionHolder
      loadActivity={loadActivity}
      saveNote={(note, currentPage, selectedLength) => services.stockItem.saveComment(item.id, note, currentPage, selectedLength)}
      setLoading={setLoading}
      openDialogs={openDialogs}
      toggleDialog={toggleDialog}
      toggleError={toggleError}
      page={page}
      length={length}
      updatePageCount={updatePageCount}
    />
  );
}
